import { Card, CardContent } from "@/components/ui/card";
import { Head } from "@inertiajs/react";
import type { Followers } from "@/types/generated";

interface FollowersProps extends Followers {}

export default function Followers({ followers }: FollowersProps) {
  return (
    <>
      <Head title="Followers" />

      <div className="container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-6">Followers</h1>

        {followers.length > 0 ? (
          <div className="space-y-4">
            {followers.map((follower) => (
              <Card key={follower.id}>
                <CardContent className="p-6">
                  <div className="flex items-center space-x-4">
                    <div className="w-12 h-12 bg-gray-300 rounded-full flex items-center justify-center">
                      <span className="text-lg font-semibold text-gray-600">
                        {follower.first_name[0]}
                        {follower.last_name[0]}
                      </span>
                    </div>
                    <div>
                      <h3 className="font-semibold text-lg">
                        {follower.first_name} {follower.last_name}
                      </h3>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        ) : (
          <Card>
            <CardContent className="p-8 text-center">
              <p className="text-gray-600 text-lg">No followers yet</p>
            </CardContent>
          </Card>
        )}
      </div>
    </>
  );
}
